<template>
  <div class="tags">
    <font-awesome-icon
      class="tags__icon"
      icon="tags"
    />
    <ul class="tags__list">
      <li
        v-for="tag in tags"
        :key="tag.slug"
        class="tags__item"
      >
        <router-link :to="{ name: 'Tags', params: { tag: tag.name } }">{{ tag.name }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    tags: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.tags
  font-size: 14px
  color: $color-grey-2
  text-align: center

.tags__icon
  font-size: 12px
  margin-right: 8px

.tags__list
  display: inline-block;

.tags__item
  display: inline-block;

  &:not(:last-child):after
    content: ', '
    display: inline-block;
    margin: 0 3px 0 1px;

  a
    color: $color-grey-2
    font-weight: 500

    &:hover
      color: black
      text-decoration: none
</style>



// WEBPACK FOOTER //
// src/components/contents/content/ContentTags.vue